export const CONTACT_US = {
  FACEBOOK: 'https://www.facebook.com/www.tap.az',
  INSTAGRAM: 'https://www.instagram.com/tap.az/',
  EMAIL: 'tap@tap.az',
  PHONE: '(012) 526-19-19',
};
